import React from 'lib/react';
import { EVGrid, EVTypography } from 'lib/components';
import { useTranslation } from 'lib/translation';
import PropTypes from 'prop-types';

import SRSBranchEmployeeFormStyles from './SRSBranchEmployeeFormStyles';

export default function SRSBranchEmployeeLabelForm({
  srsBranchEmployeeInfo,
}) {
  const classes = SRSBranchEmployeeFormStyles();
  const { t } = useTranslation();
  return (
    <EVGrid className={classes.srsInfoLabelContainer}>
      <EVGrid className={classes.srsInfoLabelContentElement}>
        <EVTypography
          id="srsInfoCustIdTitle"
          className={classes.srsInfoDetailsTitleText}
        >
          {t('order__srs_branch_employee__customer_id_title')}
        </EVTypography>
        <EVTypography className={classes.srsInfoDetailsValueText}>
          {srsBranchEmployeeInfo.srsCustId}
        </EVTypography>
      </EVGrid>
      <EVGrid className={classes.srsInfoLabelContentElement}>
        <EVTypography
          id="srsInfoShipNoTitle"
          className={classes.srsInfoDetailsTitleText}
        >
          {t('order__srs_branch_employee__ship_number_title')}
        </EVTypography>
        <EVTypography className={classes.srsInfoDetailsValueText}>
          {srsBranchEmployeeInfo.srsShipNumber}
        </EVTypography>
      </EVGrid>
    </EVGrid>
  );
}

SRSBranchEmployeeLabelForm.propTypes = {
  srsBranchEmployeeInfo: PropTypes.shape({
    srsCustId: PropTypes.string.isRequired,
    srsShipNumber: PropTypes.string.isRequired,
  }).isRequired,
};
